/**
 * Socket Client Module
 *
 * Exports the socket manager instance for use across the application
 * This provides a centralized socket connection that can be imported
 * in middleware, services, and other modules.
 */

import { socketManager } from '../contexts/SocketContext';

// Export the singleton socket manager instance
export const socket = socketManager;

// Export convenience methods
export const emit = (event, data) => socketManager.emit(event, data);
export const on = (event, handler) => socketManager.on(event, handler);
export const off = (event, handler) => socketManager.off(event, handler);
export const isConnected = () => socketManager.isConnected();

export default socket;
